import { render, staticRenderFns } from "./PPlainDetail.vue?vue&type=template&id=1feeafca&scoped=true&"
import script from "./PPlainDetail.vue?vue&type=script&lang=ts&"
export * from "./PPlainDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PPlainDetail.vue?vue&type=style&index=0&id=1feeafca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feeafca",
  null
  
)

export default component.exports